import React, { Component } from 'react';
// CSS Loaders
import 'loaders.css/loaders.css';
import 'spinkit/css/spinkit.css';

class Spinner extends Component {
    render() {
        return (
            
            <div className="d-flex justify-content-center wrapper-spinner">
                {/* <div id="overlay" className="d-flex justify-content-center" style={overlay}></div> */}
                <div className="line-scale-pulse-out content-spinner" >
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
        );
    }
}

const myStyle={
    position: 'absolute',
    zIndex: 999,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: '#ffffff80', 
    zIndex: 998, 
    cursor: 'pointer',

}

const spinner = {
    position: 'fixed',
    top: '50%',
    left: '50%',
  }

export default Spinner;